import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgForecastUpgrade(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.354 5.853a.5.5 0 01-.708 0L18 4.207l-1.646 1.646a.5.5 0 01-.708-.707L17.293 3.5a1 1 0 011.414 0l1.647 1.646a.5.5 0 010 .707zM16 11.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM11 19v-6h2v6h-2zm-1-6.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-7zM5 19v-4h2v4H5zm-1-4.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-5zM19.5 11a.5.5 0 00-.5.5v1a.5.5 0 101 0v-1a.5.5 0 00-.5-.5zm-.5 4.5a.5.5 0 011 0v1a.5.5 0 11-1 0v-1zM16.5 18a.5.5 0 00-.5.5v1a.5.5 0 101 0v-1a.5.5 0 00-.5-.5zm-.5-3.5a.5.5 0 011 0v1a.5.5 0 11-1 0v-1zm2.5 4.5a.5.5 0 000 1h1a.5.5 0 100-1h-1zm1.146-10.147a.5.5 0 00.708-.707L18.707 6.5a1 1 0 00-1.414 0l-1.647 1.646a.5.5 0 00.708.707L18 7.207l1.646 1.646z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastUpgrade);

var ForecastUpgradeOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ForecastUpgradeOutline as default };
